<script setup lang="ts">
import Icon from '~/components/global/Icon.vue'
import useQuickOfferModalStore from '~/stores/modals/useQuickOfferModal'

const quickOfferModalStore = useQuickOfferModalStore()
</script>

<template>
  <div class="c-listing-header-contact">
    <h2 class="c-listing-header-contact__title">
      {{ $t('pages.estateListing.header.contact.title') }}
    </h2>

    <div class="c-listing-header-contact__text">
      <strong>{{ $t('pages.estateListing.header.contact.text.0') }}</strong>
      {{ $t('pages.estateListing.header.contact.text.1') }}
    </div>

    <div class="c-listing-header-contact__button">
      <IButton
        class="has-icon"
        color="secondary"
        @click="quickOfferModalStore.open()"
      >
        {{ $t('pages.estateListing.header.contact.buttonText') }}

        <icon name="arrow-right-thick" />
      </IButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-listing-header-contact {
  padding: 36px 86px 36px 50px;
  background-color: var(--color-light);

  @include breakpoint-down('xl') {
    padding: 24px 50px 24px 32px;
  }

  &__title {
    font-size: 28px;
    line-height: 1.2;
    margin-bottom: 12px;
  }

  &__text {
    font-size: 16px;
    margin-bottom: 24px;
  }

  &__button {
    .button {
      --button--padding-left: 36px;
      --button--padding-right: 36px;

      min-height: 64px;
      font-weight: 500;

      @include breakpoint-down('xl') {
        --button--padding-left: 24px;
        --button--padding-right: 24px;

        min-height: 48px;
      }

      .ico {
        top: 1px;
      }
    }
  }
}
</style>
